import { render } from "./DeleteFaculty.vue?vue&type=template&id=5e728ddb&scoped=true"
import script from "./DeleteFaculty.vue?vue&type=script&lang=js"
export * from "./DeleteFaculty.vue?vue&type=script&lang=js"

import "../css/DeletingList.css?vue&type=style&index=0&id=5e728ddb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e728ddb"]])

export default __exports__